export const HIDDEN_ROUTES_ON_VERTICAL_KIOSK: string[] = [
  '/ga4',
  '/poc/inputs',
  '/fullStory',
  '/seat',
  '/srIrops',
  '/notice-proposed-flight',
];

export const DIMENSION_BAG_LIMIT = 175;
export const LABEL_DIMENSION_BAG_LIMIT = 158;
/* Altura (cm) para"Equipaje demasiado alto" */
export const MAX_HEIGHT = 66;
/* Altura (grosor) máxima esperada de UNA sola maleta acostada */
export const MAX_SINGLE_BAG_HEIGHT = 40;
/* Mínimo (cm) esperado para el ancho y el largo de una maleta bien colocada (acostada) */
export const MIN_BAG_DIMENSION = 20;
/* Estado de la respuesta AEA ("HDCBQNI"; "HDCBQOK" = maleta asentada). */
export const BAG_QUERY_INVALID_READ_STATUS = 'NI';
export const EMERGENCY_BELT_STATUS = 'EMCY';
